import { useMutation, useQuery } from "@tanstack/react-query";
export const createPaymentsQueries = (requests, queryClient) => ({
    useInitializePayment: (options = {}) => useMutation({
        ...options,
        mutationFn: (payload) => requests.initializePayment(payload),
    }),
    useFindPayment: (params, options = {}) => useQuery({
        ...options,
        queryKey: ["payments", params],
        queryFn: ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.findPayment(params);
        },
    }),
});
//# sourceMappingURL=index.js.map